import { useEffect } from "react";

/**
 * Lightweight GA4 loader. Activates automatically as soon as
 * REACT_APP_GA4_MEASUREMENT_ID is set in /app/frontend/.env (e.g. "G-XXXXXXXXXX").
 * No-ops when the env var is empty, so this is safe to ship enabled.
 */
const GoogleAnalytics = () => {
  useEffect(() => {
    const id = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
    if (!id) return;
    if (document.querySelector(`script[data-ga="${id}"]`)) return;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    s.setAttribute("data-ga", id);
    document.head.appendChild(s);

    const inline = document.createElement("script");
    inline.setAttribute("data-ga-inline", id);
    inline.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${id}',{anonymize_ip:true});`;
    document.head.appendChild(inline);
  }, []);

  return null;
};

export default GoogleAnalytics;
